import React from 'react'
import "./index.scss"

function Footer() {
  return (
    <footer>
      👾 Website provided by the Computing Club of Montclair State University 👾
    </footer>
  );
}

export default Footer